export default {
  computed: {
    schemaFasilitator2023() {
      const bulan = this.$getDeepObj(this.info, 'bulan') || '';

      let result = {
        dasar: {
          title: 'Gambaran Umum Kegiatan',
          laporan: [
            {
              type: 'textView',
              label: 'Bulan Pelaksanaan',
              labelColor: 'indigo',
              bgColor: 'grey lighten-3 pa-2 mb-4',
              value: bulan || '',
              grid: { cols: 12, md: 6 },
            },
            {
              type: 'VDatePicker',
              name: 'tgl_pelaksanaan',
              label: 'Tanggal Pelaksanaan',
              labelColor: 'indigo',
              usePrependInnerIcon: 'mdi-calendar-month',
              hint: 'wajib diisi',
              required: true,
              outlined: true,
              singleLine: true,
              hideDetails: true,
              dense: true,
              grid: { cols: 12, md: 6, sm: 12 },
            },
            {
              disabled: this.isPreview,
              type: 'VSelect',
              name: 'k_koordinator_moda_psp',
              label: 'Moda yang diterapkan',
              labelColor: 'indigo',
              hint: 'wajib diisi',
              items: this.$mapForMaster(this.$getDeepObj(this.masters, 'koordinator_moda_psp') || {}),
              outlined: true,
              singleLine: true,
              hideDetails: true,
              readonly: this.readOnly,
              dense: true,
              grid: { cols: 12, md: 6, sm: 12 },
            },
            {
              disabled: this.isPreview,
              type: 'VSelect',
              name: 'durasi',
              label: 'JP Kegiatan',
              labelColor: 'indigo',
              hint: 'wajib diisi',
              items: [
                { text: '3 JP', value: 3 },
                { text: '4 JP', value: 4 },
              ],
              outlined: true,
              singleLine: true,
              readonly: this.readOnly,
              dense: true,
              hideDetails: true,
              grid: { cols: 12, md: 6, sm: 12 },
            },
            {
              type: 'VAutocomplete',
              name: 'absensi',
              label: 'Daftar FSP yang hadir',
              placeholder: 'Pilih FSP yang hadir',
              labelColor: 'indigo',
              hint: 'wajib diisi',
              slot: 'selection',
              items: this.listFspDampingan || [],
              grid: { cols: 12, md: 6 },
              multiple: true,
              outlined: true,
              dense: true,
              singleLine: true,
            },
          ],
        },
        kegiatan: {
          title: 'Pelaksanaan Kegiatan',
          laporan: this.listInstrumen['fsp'],
        },
      };

      if (+this.form[`instrumen-radio-5`] === 41) {
        result = Object.assign({}, result, {
          pmo: {
            title: 'Monitoring PMO Level Sekolah oleh Kepala Sekolah',
            laporan: this.listInstrumen['pmo'],
          },
        });
      }

      return result;
    },
  },
};
